/**
 * Versione centralizzata dell'applicazione
 * Aggiornare SOLO questo file per cambiare la versione
 */

export const APP_VERSION = '1.3.2'
export const APP_VERSION_DATE = '13 Gennaio 2026'

// Per compatibilità con il manuale
export const MANUAL_VERSION = APP_VERSION
export const MANUAL_LAST_UPDATE = APP_VERSION_DATE
